import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is social media marketing?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Social media marketing (SMM) is the process of promoting a business or brand through platforms like Facebook, Instagram, LinkedIn, and Twitter to build awareness, engagement, and conversions."
      }
    },
    {
      "@type": "Question",
      "name": "Which platforms do you manage?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I manage content and ads for Facebook, Instagram, LinkedIn, Twitter, and YouTube based on the client’s goals and target audience."
      }
    },
    {
      "@type": "Question",
      "name": "Do you run paid campaigns too?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I set up, manage, and optimize paid social campaigns including Facebook Ads, Instagram promotions, and LinkedIn Sponsored Posts."
      }
    },
    {
      "@type": "Question",
      "name": "Can you create social media content?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I design posts, write engaging captions, plan content calendars, and ensure consistency across all platforms."
      }
    },
    {
      "@type": "Question",
      "name": "What are your SMM services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "My services include content strategy, graphics design, hashtag research, post scheduling, ad campaign setup, analytics, and community management."
      }
    },
    {
      "@type": "Question",
      "name": "How often will you post?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Posting frequency depends on the package. It usually ranges from 3 to 5 times per week, with reels, stories, and carousels as needed."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide monthly reports?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. You'll receive monthly reports showing reach, engagement, followers gained, and ad performance metrics."
      }
    },
    {
      "@type": "Question",
      "name": "Can you grow my business followers organically?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I use organic strategies like consistent branding, content optimization, reels, trends, and targeted hashtags to grow reach and engagement."
      }
    },
    {
      "@type": "Question",
      "name": "Do you work with small businesses or startups?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I specialize in affordable SMM packages for startups, freelancers, and local businesses who want to build a strong online presence."
      }
    },
    {
      "@type": "Question",
      "name": "How soon can I start seeing results?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Engagement growth starts within 2–4 weeks. Follower and lead generation depends on your goals, consistency, and whether paid ads are used."
      }
    },
    {
      "@type": "Question",
      "name": "Is social media marketing good for lead generation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. With the right content and ad strategy, social media platforms can generate leads, increase website visits, and boost conversions."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Social Media Marketing Services in Gurgaon | SMM by Freelance Expert Pankaj</title>

<meta name="description" content="Boost your brand’s presence on Facebook, Instagram, LinkedIn, and more with expert social media marketing services by Pankaj, a freelance digital marketer in Gurgaon." />

<meta name="keywords" content="social media marketing gurgaon, freelance smm expert, social media manager india, instagram marketing services, facebook ad specialist, linkedin b2b marketing, social media content creation, influencer marketing india, paid social campaigns, freelance digital marketer gurgaon" />

<meta property="og:title" content="Social Media Marketing Services in Gurgaon | SMM by Freelance Expert Pankaj" />
<meta property="og:description" content="Result-driven social media marketing for Facebook, Instagram, LinkedIn & more. Content, ads, and strategy by freelance expert in India." />
<meta property="og:site_name" content="Pankaj | Freelance Social Media Marketer" />
<meta property="og:url" content="https://www.pankj.com/social-media-marketing" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<meta name="twitter:title" content="Social Media Marketing Services in Gurgaon | SMM by Freelance Expert Pankaj" />
<meta name="twitter:description" content="Grow your audience, engagement, and conversions with professional SMM services by Pankaj. Gurgaon-based freelance digital marketer." />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<link rel="canonical" href="https://www.pankj.com/social-media-marketing" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects fzsml" id="text3d">Social Media Marketing</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">

 <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Social Media Marketing</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
<div class="hero-section text-center">
  <p>Grow Your Business with Targeted Social Media Marketing on Facebook, Instagram, and LinkedIn</p>
  <a href="/contact" class="btn btn-primary mt-3">Get Your Free SMM Strategy</a>
</div>

<div class="intro-section py-5">
  <h2>Why Social Media Marketing?</h2>
  <p>With billions of users across Facebook, Instagram, LinkedIn, and Twitter, your audience is already online. Social Media Marketing (SMM) helps you connect with them, build trust, and drive sales — through organic content, paid ads, or both.</p>
  <p>As a freelance digital marketer based in Gurgaon, I offer cost-effective, high-impact social media marketing services tailored to your goals — whether you need branding, traffic, leads, or engagement.</p>
</div>

<div class="services-section py-5">
  <h2>What’s Included in My SMM Services</h2>
  <ul>
    <li>✅ Custom Content Strategy & Calendar</li>
    <li>✅ High-Quality Posts, Reels, Stories, and Carousels</li>
    <li>✅ Hashtag & Trend Research</li>
    <li>✅ Facebook & Instagram Ad Campaigns</li>
    <li>✅ LinkedIn B2B Marketing</li>
    <li>✅ Audience Targeting & Retargeting</li>
    <li>✅ Profile Optimization & Branding</li>
    <li>✅ Monthly Performance Reports</li>
  </ul>
</div>

<div class="benefits-section py-5">
  <h2>How Social Media Helps Your Business</h2>
  <p>✔ Reach thousands of potential customers daily</p>
  <p>✔ Increase brand awareness and trust</p>
  <p>✔ Engage your audience with relevant content</p>
  <p>✔ Drive website traffic and collect leads</p>
  <p>✔ Launch targeted ads with measurable ROI</p>
</div>

<div class="faq-section py-5">
  <h2>Frequently Asked Questions</h2>

  <div class="faq-item">
    <h3>Which platforms do you manage?</h3>
    <p>I manage Facebook, Instagram, LinkedIn, Twitter, and YouTube based on your audience and goals.</p>
  </div>

  <div class="faq-item">
    <h3>Do you also run ads?</h3>
    <p>Yes. I set up, manage, and optimize ad campaigns for Facebook, Instagram, and LinkedIn to maximize reach and conversions.</p>
  </div>

  <div class="faq-item">
    <h3>Will you create the posts?</h3>
    <p>Yes. I design creative graphics, write captions, plan hashtags, and schedule posts as per your brand tone and calendar.</p>
  </div>

  <div class="faq-item">
    <h3>Do I need to give you access to my accounts?</h3>
    <p>Yes. I will request access to your social profiles (or create them for you) so I can manage content and ads securely.</p>
  </div>

  <div class="faq-item">
    <h3>How often will you post?</h3>
    <p>Depending on the package, I typically post 3–5 times per week — including stories, reels, and static posts.</p>
  </div>

  <div class="faq-item">
    <h3>Will you provide monthly reports?</h3>
    <p>Yes. I share monthly performance reports showing reach, engagement, followers, and ad metrics.</p>
  </div>

  <div class="faq-item">
    <h3>Is this good for lead generation?</h3>
    <p>Yes. I use lead forms, landing pages, and retargeting ads to generate qualified leads through social media.</p>
  </div>
</div>

<div class="cta-section py-5 text-center">
  <h2>Let’s Build Your Brand Online</h2>
  <p>Get high-converting content and campaigns that connect with your audience. Start building your digital brand today!</p>
  <a href="/contact" class="btn btn-success mt-3">Book Free Consultation</a>
</div>

          </div>

        </div>
      </div>

    </section>
        <Contact /> 
    </main>
    </>
  );
}
export default App1;
